export const comics = [
  {
    id: 1,
    title: "我的ID是江南美人",
    category: "恋爱",
    author: "淇萌琪",
    status: "连载中",
    rating: 9.5,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20webtoon%20cover%20art%2C%20beautiful%20female%20protagonist%20with%20long%20hair%2C%20soft%20pastel%20colors%2C%20clean%20minimal%20background%2C%20professional%20illustration%20style%2C%20romantic%20atmosphere%2C%20elegant%20character%20design%2C%20manga%20art%20style%20with%20refined%20linework%2C%20warm%20lighting%2C%20simple%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    description: "从小因为外貌丑陋而备受欺凌的姜美来，通过整容手术获得了全新的容貌。进入大学后，她本以为可以开始崭新的人生，却意外卷入了关于外貌、自信与真爱的成长故事。都炅锡，一个天生拥有完美外貌却对「外貌至上主义」深恶痛绝的男生，能否看透美来的内心？",
    tags: ["校园", "恋爱", "成长", "治愈"],
    chapters: 156,
    updateDate: "2026-07-02",
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: "全知读者视角",
    category: "奇幻",
    author: "singNsong",
    status: "连载中",
    rating: 9.8,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20webtoon%20cover%20art%2C%20male%20protagonist%20with%20dark%20hair%20in%20apocalyptic%20setting%2C%20dramatic%20lighting%2C%20cool%20blue%20and%20dark%20tones%2C%20action%20pose%2C%20professional%20illustration%20style%2C%20mysterious%20atmosphere%2C%20constellation%20motif%2C%20clean%20background%2C%20manga%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    description: "金独子是一个普通上班族，十年来他唯一的乐趣就是阅读一部名为《在灭亡的世界中生存的三种方法》的网络小说。当这部小说完结的那一天，小说中的末日场景竟然在现实中降临了。作为唯一读完这部小说的人，金独子成为了这个毁灭世界的「全知读者」。",
    tags: ["奇幻", "末世", "系统", "悬疑"],
    chapters: 213,
    updateDate: "2026-07-03",
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: "我独自升级",
    category: "动作",
    author: "Chugong",
    status: "已完结",
    rating: 9.7,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20webtoon%20cover%20art%2C%20male%20hunter%20with%20dark%20armor%20and%20glowing%20eyes%2C%20dramatic%20purple%20and%20black%20color%20scheme%2C%20dynamic%20action%20pose%2C%20professional%20illustration%2C%20shadow%20warriors%20silhouette%2C%20epic%20fantasy%20style%2C%20clean%20dark%20background%2C%20powerful%20character%20design&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    description: "在被称为「猎人」的超能力者世界中，成振宇是被称为「人类最弱兵器」的E级猎人。在一次几乎全灭的地下城探险中，他被系统选中，获得了独一无二的「升级」能力。从此，他踏上了从最弱到最强的逆袭之路。",
    tags: ["动作", "奇幻", "升级流", "热血"],
    chapters: 179,
    updateDate: "2025-12-20",
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: "她的私生活",
    category: "恋爱",
    author: "金成妍",
    status: "连载中",
    rating: 9.3,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20webtoon%20cover%20art%2C%20elegant%20woman%20in%20office%20attire%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20professional%20illustration%20style%2C%20pink%20and%20cream%20color%20tones%2C%20clean%20minimal%20background%2C%20manga%20art%20with%20refined%20linework%2C%20charming%20character%20expression&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    description: "成德美是一位专业的策展人，表面上她是一位完美无缺的职场女性。但鲜为人知的是，她私下是一名狂热的偶像追星族。当她遇到严苛的新任馆长莱恩·金时，她的双重生活开始面临前所未有的挑战。",
    tags: ["恋爱", "职场", "喜剧", "治愈"],
    chapters: 98,
    updateDate: "2026-07-01",
    featured: false,
    hot: false,
  },
  {
    id: 5,
    title: "神之塔",
    category: "奇幻",
    author: "SIU",
    status: "连载中",
    rating: 9.6,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20webtoon%20cover%20art%2C%20young%20boy%20climbing%20mysterious%20tower%2C%20epic%20scale%2C%20golden%20and%20teal%20color%20palette%2C%20professional%20illustration%2C%20mysterious%20atmosphere%2C%20detailed%20background%20with%20floating%20elements%2C%20adventure%20theme%2C%20clean%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    description: "二十五夜是一个孤独的少年，他的整个世界就是封闭他的洞穴和唯一的朋友蕾哈尔。当蕾哈尔决定攀登神秘的神之塔时，二十五夜追随她进入了这个充满危险与奇迹的世界。塔的每一层都隐藏着秘密和试炼。",
    tags: ["奇幻", "冒险", "友情", "神秘"],
    chapters: 550,
    updateDate: "2026-06-28",
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: "梨泰院Class",
    category: "剧情",
    author: "赵光真",
    status: "已完结",
    rating: 9.4,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20webtoon%20cover%20art%2C%20young%20entrepreneur%20with%20determined%20expression%2C%20urban%20nightlife%20setting%2C%20warm%20neon%20lights%2C%20professional%20illustration%20style%2C%20modern%20city%20atmosphere%2C%20red%20and%20dark%20tones%2C%20rebellious%20spirit%2C%20clean%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    description: "朴世路因反抗校园霸凌而入狱，出狱后他决定在梨泰院开设一家小酒馆，以此向害死他父亲的巨大餐饮集团复仇。这是一部关于信念、友情和正义的暖心励志故事。",
    tags: ["剧情", "励志", "复仇", "都市"],
    chapters: 80,
    updateDate: "2025-06-15",
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: "社内相亲",
    category: "恋爱",
    author: "海华",
    status: "已完结",
    rating: 9.2,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20webtoon%20cover%20art%2C%20pretty%20woman%20in%20elegant%20dress%2C%20romantic%20date%20atmosphere%2C%20soft%20pink%20and%20peach%20colors%2C%20professional%20illustration%2C%20lighthearted%20mood%2C%20clean%20minimal%20background%2C%20charming%20character%20design%2C%20manga%20art%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    description: "申夏莉代替闺蜜去参加相亲，本打算用浮夸的演技吓跑对方，却意外发现相亲对象竟是自家公司的社长姜泰武。一场充满搞笑与心动的社内秘密恋爱就此展开。",
    tags: ["恋爱", "喜剧", "职场", "甜宠"],
    chapters: 60,
    updateDate: "2025-03-10",
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: "女神降临",
    category: "恋爱",
    author: "猫咪",
    status: "已完结",
    rating: 9.1,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20webtoon%20cover%20art%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20school%20setting%2C%20bright%20and%20cheerful%20colors%2C%20professional%20illustration%20style%2C%20beauty%20theme%2C%20soft%20pastel%20background%2C%20cute%20character%20design%2C%20manga%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    description: "林周京因为外貌在学校备受欺凌，通过化妆技巧变身为校园女神。她小心翼翼地隐藏着自己的素颜秘密，却遇到了唯一见过她素颜的校草李修豪。一段关于自信、美丽与真爱的校园故事。",
    tags: ["恋爱", "校园", "美妆", "治愈"],
    chapters: 160,
    updateDate: "2025-01-20",
    featured: false,
    hot: false,
  },
  {
    id: 9,
    title: "深渊的天空",
    category: "奇幻",
    author: "尹仁完",
    status: "连载中",
    rating: 9.5,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20drama%20webtoon%20cover%20art%2C%20mysterious%20girl%20with%20magical%20powers%2C%20celestial%20and%20cosmic%20background%2C%20soft%20blue%20and%20silver%20tones%2C%20professional%20illustration%2C%20ethereal%20atmosphere%2C%20fantasy%20magic%20theme%2C%20clean%20composition%2C%20manga%20art%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    description: "在人类和妖魔共存的世界中，天庭和深渊之间的战争从未停止。一个失去记忆的少女和一名被流放的天使，他们命运的相遇将揭开这个世界最深的秘密。",
    tags: ["奇幻", "冒险", "神秘", "剧情"],
    chapters: 120,
    updateDate: "2026-06-25",
    featured: false,
    hot: true,
  },
  {
    id: 10,
    title: "弱英雄",
    category: "动作",
    author: "SEOPASS",
    status: "连载中",
    rating: 9.6,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20school%20webtoon%20cover%20art%2C%20skinny%20student%20fighting%20pose%2C%20intense%20dramatic%20lighting%2C%20dark%20and%20moody%20colors%2C%20professional%20illustration%2C%20street%20fight%20aesthetic%2C%20gritty%20urban%20background%2C%20manga%20art%20style%20with%20sharp%20linework&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    description: "延施恩是一个身材瘦小但智商超群的学生，在学校遭受校园霸凌后，他决定用自己的方式反击。不需要蛮力，他用精准的计算和心理战术对抗比他强大的对手。",
    tags: ["动作", "校园", "心理", "智斗"],
    chapters: 200,
    updateDate: "2026-07-01",
    featured: true,
    hot: false,
  },
  {
    id: 11,
    title: "金秘书为何那样",
    category: "恋爱",
    author: "郑庆允",
    status: "已完结",
    rating: 9.3,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20webtoon%20cover%20art%2C%20confident%20woman%20in%20business%20suit%2C%20elegant%20office%20setting%2C%20warm%20professional%20atmosphere%2C%20soft%20beige%20and%20cream%20colors%2C%20professional%20illustration%2C%20manga%20art%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    description: "金微笑作为副会长李英俊的秘书工作了九年，是公司公认的完美秘书。当她突然提出辞职时，一向自恋的李英俊才意识到金秘书对他的重要性，开始了一场啼笑皆非的挽留攻势。",
    tags: ["恋爱", "职场", "喜剧", "甜宠"],
    chapters: 87,
    updateDate: "2024-11-05",
    featured: false,
    hot: false,
  },
  {
    id: 12,
    title: "公爵的契约未婚妻",
    category: "奇幻",
    author: "Milcha",
    status: "连载中",
    rating: 9.4,
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20webtoon%20cover%20art%2C%20noble%20woman%20in%20elegant%20gown%2C%20European%20aristocratic%20setting%2C%20golden%20and%20cream%20color%20palette%2C%20professional%20illustration%2C%20royal%20atmosphere%2C%20vintage%20elegance%2C%20romantic%20fantasy%20theme%2C%20clean%20composition&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    description: "被家人视为棋子的贵族少女，为了摆脱命运与冷酷的公爵签订了一份契约婚约。她原以为这只是一场交易，却不知公爵心中藏着比她想象中更深的秘密。",
    tags: ["奇幻", "恋爱", "贵族", "契约"],
    chapters: 145,
    updateDate: "2026-07-02",
    featured: false,
    hot: true,
  },
];

export const categories = [
  { name: "恋爱", slug: "romance", icon: "ri-heart-line", count: 1280 },
  { name: "奇幻", slug: "fantasy", icon: "ri-magic-line", count: 956 },
  { name: "动作", slug: "action", icon: "ri-sword-line", count: 742 },
  { name: "剧情", slug: "drama", icon: "ri-emotion-line", count: 568 },
  { name: "悬疑", slug: "thriller", icon: "ri-search-eye-line", count: 321 },
  { name: "喜剧", slug: "comedy", icon: "ri-emotion-happy-line", count: 456 },
  { name: "恐怖", slug: "horror", icon: "ri-ghost-line", count: 189 },
  { name: "BL", slug: "bl", icon: "ri-user-heart-line", count: 234 },
];

export const siteInfo = {
  name: "奇妙漫画网",
  slogan: "免费韩漫在线阅读 - 好看的韩国漫画大全",
  description: "奇妙漫画网提供免费韩漫在线阅读服务，汇集好看的韩国漫画和韩国漫画大全。无论您喜欢恋爱、奇幻、动作还是剧情漫画，在这里都能找到心仪的作品。我们致力于为漫画爱好者提供流畅的阅读体验和个性化的漫画推荐。",
  about: "奇妙漫画网成立于2020年，是国内领先的韩国漫画在线阅读平台。我们与多家韩国漫画工作室合作，为用户提供最新、最全的韩漫资源。平台累计收录漫画超过5000部，覆盖恋爱、奇幻、动作、剧情等十余个分类，月活跃用户突破500万。我们始终坚持免费阅读的理念，致力于让每一位漫画爱好者都能享受优质的韩漫内容。",
  email: "hello@xinzhewash.com",
  foundingYear: "2020",
  userCount: "500万+",
  comicCount: "5000+",
  categoryCount: "12",
};

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20photo%2C%20casual%20style%2C%20friendly%20smile%2C%20clean%20light%20background%2C%20professional%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20composition&width=200&height=200&seq=avatar-01&orientation=squarish",
    content: "奇妙漫画网是我每天必刷的网站！更新速度超快，画质也特别好。分类很全，我喜欢的恋爱和奇幻韩漫这里都有。推荐给了身边所有喜欢韩漫的朋友！",
    rating: 5,
  },
  {
    id: 2,
    name: "韩漫达人小李",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20photo%2C%20stylish%20look%2C%20warm%20smile%2C%20clean%20light%20background%2C%20professional%20headshot%2C%20natural%20lighting%2C%20simple%20composition&width=200&height=200&seq=avatar-02&orientation=squarish",
    content: "从大学开始看韩漫，用过很多平台，奇妙漫画网的阅读体验是最好的。页面简洁没有广告干扰，漫画资源也很丰富。五星好评！",
    rating: 5,
  },
  {
    id: 3,
    name: "追更狂魔阿杰",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20man%20portrait%20photo%2C%20trendy%20casual%20style%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20bright%20natural%20lighting%2C%20simple%20composition&width=200&height=200&seq=avatar-03&orientation=squarish",
    content: "追了三年韩漫，奇妙漫画网的更新提醒功能太好用了！再也不怕错过最新章节。热门推荐也很精准，发现了好几部宝藏漫画。强烈推荐！",
    rating: 5,
  },
];